<div id="countdown-container">
  <div class="overlay" [class.active]="countdown > 0">
    <div *ngIf="countdown" class="countdown">
      <h2 #countdownText>{{ countdown }}</h2>
    </div>
  </div>
  <div *ngIf="shutter" class="shutter" [class.active]="countdown === 0"></div>
</div>
